import React from 'react';
import PermissionRoles from './PermissionRoles';
import TemplatesPermissions from './TemplatesPermissions';
import { Pivot, PivotItem } from '@fluentui/react';
import MasterDataManagersPanel from './MasterDataManagersPanel';
import PowerAppsLicenseApprovers from './PowerAppsLicenseApprovers';
import { addPivotItemKeyToUrl, getPivotItemKeyFromUrl } from '../../helpers/HelperMethods';
import CustomApplicationsConfigPanel from './CustomApplicationsConfigPanel';
import ReleaseNotes from './ReleaseNotes';
import UserGuidesTabs from './UserGuidesTabs';
import PowerPlatformWhitelisting from './PowerPlatformWhitelisting';

export default class SettingsPanel extends React.Component
{
    
    render() {
        //temporary solution to disable power app licenses
        const enablePowerAppLicensing = false;

        const defaultSelectedKey = getPivotItemKeyFromUrl('Roles');

        return (
            <div>
                <Pivot styles={pivotStyles} defaultSelectedKey={defaultSelectedKey} onLinkClick={addPivotItemKeyToUrl()}>
                    <PivotItem itemKey='Roles' headerText='Roles'>
                        <PermissionRoles />
                    </PivotItem>
                    <PivotItem itemKey='TemplatesPermissions' headerText='Templates Permissions'>
                        <TemplatesPermissions />
                    </PivotItem>
                    <PivotItem itemKey='OrganizationManagers' headerText='Organization Managers'>
                        <MasterDataManagersPanel parentPivotKey={'OrganizationManagers'} />
                    </PivotItem>
                    {
                    enablePowerAppLicensing &&    
                    <PivotItem itemKey='PowerAppsLicense' headerText='PowerApps License Approvers'>
                        <PowerAppsLicenseApprovers />
                    </PivotItem>
                    }
                    <PivotItem itemKey='CustomApplicationsConfigPanel' headerText='Custom Applications'>
                        <CustomApplicationsConfigPanel />
                    </PivotItem>
                    <PivotItem itemKey='ReleaseNotes' headerText='Release Notes'>
                        <ReleaseNotes />
                    </PivotItem>
                    <PivotItem itemKey='UserGuidesAdmin' headerText='User Guides'>
                        <UserGuidesTabs parentPivotKey='UserGuidesAdmin' adminEditMode={true}/>
                    </PivotItem>
                    <PivotItem itemKey='PowerAppWhitelisting' headerText='Power Platform Whitelisting'>
                        <PowerPlatformWhitelisting />
                    </PivotItem>
                </Pivot>
            </div>
        );
    }
}

const pivotStyles = {
    root: {
        marginBottom: 20
    },
    linkContent: {
        fontSize: 16,
    }
}


// WEBPACK FOOTER //
// ./src/components/Settings/SettingsPanel.js